import React, { useEffect, useState } from "react";
import PropTypes from 'prop-types';
import LoadingSpinner from '../LoadingSpinner';

const HubspotForm = ({formId}) => {
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const script = document.createElement('script');
        script.src='https://js.hsforms.net/forms/v2.js';
        document.body.appendChild(script);

        script.addEventListener('load', () => {
            if (window.hbspt && formId) {
                setLoading(false);
                window.hbspt.forms.create({
                    portalId: '49145195',
                    formId: formId,
                    target: '#hubspotForm'
                })
            }
        });
    }, []);

    return (
        <div className="form-wrapper">
            {loading ? <LoadingSpinner fullPage={false} /> : null}
            <div id="hubspotForm"></div>
        </div>
    );
}

HubspotForm.propTypes = {
  formId: PropTypes.string,
};

export default HubspotForm;
